import React, { useContext, useEffect, useRef, useState } from "react";
import ViewerContext from "../../context/ViewerContext";
import { CallbackProperty, Cartesian3, Color, EventHelper } from "cesium";

const CreateLinkDataSource = () => {
  const { allData, setLinkChangeList } = useContext(ViewerContext);
  const allDataRef = useRef();

  useEffect(() => {
    dataSourceEventHandling();
  }, []);

  useEffect(() => {
    allDataRef.current = allData;

    if (
      allData &&
      allData.hasOwnProperty("rx_stations") &&
      allData.hasOwnProperty("links")
    ) {
      pilotLinkConnections(allData.links, allData.rx_stations);
    }
  }, [allData]);

  const pilotLinkConnections = (linkList, stationList) => {
    if (!linkList) return;

    const linkUpdates = []
    let satelliteDataSource = viewer.dataSources.getByName(
      "satellite-data-source"
    )[0];

    if (!satelliteDataSource) return;

    linkList.forEach((linkItem) => {
      const rxStation = stationList.find(
        (e) => e.name == linkItem.rx_station_name
      );
      if (!rxStation) return;

      const {
        name: stationName,
        latitude_degn: lat,
        longitude_dege: lon,
        altitude_m: alt,
      } = rxStation;

      const linkSatelliteId = linkItem.satellite_norad_id;

      const linkId = `link-${stationName.trim()}`;
      const linkEntity = viewer.entities.getById(linkId);

      if (!linkEntity) {
        var createdEntity = viewer.entities.add({
          id: linkId,
          type: "link",
          satelliteId: linkSatelliteId,
          station: stationName.trim(),
          name: `Link ${stationName}`,
          // properties: props,
          polyline: {
            positions: new CallbackProperty(function (time, result) {
              const groundPosition = Cartesian3.fromDegrees(lon, lat, alt);

              if (!createdEntity.satelliteId) return [groundPosition];

              const satelliteEntity = satelliteDataSource.entities.getById(
                createdEntity.satelliteId
              );

              if (!satelliteEntity) {
                console.log(
                  "Linked Satellite not found id= " + createdEntity.satelliteId
                );
                return [groundPosition];
              }
              var satellitePos = satelliteEntity.position.getValue(
                time,
                result
              );

              if (!satellitePos) {
                return [groundPosition];
              }
              return [groundPosition, satellitePos];
            }, false),
            width: 5,
            material: Color.RED,
          },
        });
      } else {
        if(linkSatelliteId != linkEntity.satelliteId){
          console.log("link id changed")
          linkUpdates.push({
            newSatId: linkSatelliteId,
            oldSatId: linkEntity.satelliteId,
            stationName: stationName
          })
        }
        linkEntity.satelliteId = linkSatelliteId;
      }
    });

    setLinkChangeList(linkUpdates)
  };

  const dataSourceEventHandling = () => {
    const cesiumEventHelper = new EventHelper();

    const cesiumDataSourceAddListener = (dataSource) => {
      pilotLinkConnections(allDataRef.current.links, allDataRef.current.rx_stations);
    };

    cesiumEventHelper.add(
      viewer.dataSources.dataSourceAdded,
      cesiumDataSourceAddListener,
      cesiumEventHelper
    );
  };

  return <></>;
};

export default CreateLinkDataSource;
